<template>
  <div v-bind:class="{ 'form-group': true, 'has-error': this.m_error !== null }">
    <label>{{ field.label }}</label>
    <the-mask
      :mask="['(##) ####-####', '(##) #####-####']"
      type="text"
      :masked="true"
      placeholder="Entre com o telefone"
      class="form-control"
      v-model="m_fieldAnswer.value"
      :disabled="disabledAttribute"
    />
  </div>
</template>

<script>
  import TheMask from 'vue-the-mask'

  export default {
    props: ['field', 'fieldAnswer', 'isDisabled'],
    name: 'PhoneNumberField',
    components: { TheMask },
    data () {
      return {
        m_fieldAnswer: {
          fieldUuid: this.field.uuid,
          value: this.fieldAnswer.value
        },
        m_error: null,
        m_rowIndex: this.fieldAnswer.rowIndex
      }
    },
    computed: {
      disabledAttribute () {
        return this.field.disabled === true || this.isDisabled === true
      }
    },
    watch: {
      'm_fieldAnswer.value' () {
        this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer)
      }
    },
    methods: {
      isValid () {
        if (this.field.required && !this.m_fieldAnswer.value) {
          this.m_error = true
          return false
        }
        this.m_error = null
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PhoneNumberField.vue?b667568e